export const REQUEST_TIMEOUT = 30000;
export const BATCH_REQUEST_ID = 35508;
export const TRANSACTION_HISTORY_REQUEST_ID = 32012; /* Lugano changes */
